import { Sentiment } from 'integrations/lib/review-analysis/functions/types'
import { Translator } from '../i18n'

const getSentimentName = (t: Translator, name: Sentiment) => t(`tag.sentiment.${name.toLocaleLowerCase()}`)

// Note: this handles the fact that all tags are saved uppercased, fix later
export const translateSystemTag = (t: Translator, tagName: string) =>
  tagName.toLocaleLowerCase().startsWith('ai:s:') ? getSentimentName(t, tagName.substring(5) as Sentiment) : tagName
